/**
 * custom-product-page.js  |  Grifigo Theme — Advanced Product Page
 *
 * 1. Feature pills — injected above description if product tags exist
 * 2. Gallery builder — restructures description images into
 *    Featured (hero) + thumbnails grid
 * 3. Advanced Lightbox — full-screen viewer with prev/next nav + counter
 */
(function () {
  'use strict';

  var galleryImages = []; // [{src, alt}, …] collected during gallery build
  var lightboxIndex = 0;

  // ── 1. Feature Pills ──────────────────────────────────────────────────────
  function buildPills() {
    var box = document.querySelector('.cpl-description-box');
    if (!box) return;

    // Read product tags from a data attribute set in the Liquid template
    var tagsEl = document.getElementById('cpl-product-tags');
    if (!tagsEl) return;

    var tags = (tagsEl.textContent || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    if (tags.length === 0) return;

    var pillsWrap = document.createElement('div');
    pillsWrap.className = 'cpl-pills';

    tags.slice(0, 6).forEach(function (tag) {
      var pill = document.createElement('span');
      pill.className = 'cpl-pill';
      pill.textContent = tag;
      pillsWrap.appendChild(pill);
    });

    // Insert pills before .cpl-description-content
    var descContent = box.querySelector('.cpl-description-content');
    if (descContent) box.insertBefore(pillsWrap, descContent);
  }

  // ── 2. Gallery Builder ────────────────────────────────────────────────────
  function buildGallery() {
    var container = document.querySelector('.cpl-description-content');
    if (!container) return;

    var imgs = Array.from(container.querySelectorAll('img'));
    if (imgs.length === 0) return;

    // Collect image data and detach from DOM
    galleryImages = [];
    imgs.forEach(function (img) {
      galleryImages.push({ src: img.src, alt: img.alt || '' });
      var parent = img.parentNode;
      parent.removeChild(img);
      if (parent && parent !== container && parent.innerHTML.trim() === '') {
        parent.parentNode && parent.parentNode.removeChild(parent);
      }
    });

    // Build gallery container
    var gallery = document.createElement('div');
    gallery.className = 'cpl-desc-gallery';

    // Hero image (first)
    var first = galleryImages[0];
    var heroWrap = document.createElement('div');
    heroWrap.className = 'cpl-desc-gallery-hero';
    heroWrap.setAttribute('role', 'button');
    heroWrap.setAttribute('tabindex', '0');
    heroWrap.setAttribute('aria-label', 'View image 1');
    heroWrap.dataset.cplIndex = '0';

    var heroImg = document.createElement('img');
    heroImg.src = first.src;
    heroImg.alt = first.alt;
    heroImg.loading = 'lazy';
    heroWrap.appendChild(heroImg);
    gallery.appendChild(heroWrap);

    // Thumbnails (remaining)
    if (galleryImages.length > 1) {
      var thumbsGrid = document.createElement('div');
      thumbsGrid.className = 'cpl-desc-gallery-thumbs';

      galleryImages.slice(1, 4).forEach(function (imgData, i) {
        var item = document.createElement('div');
        item.className = 'cpl-desc-gallery-item';
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.setAttribute('aria-label', 'View image ' + (i + 2));
        item.dataset.cplIndex = String(i + 1);

        var thumbImg = document.createElement('img');
        thumbImg.src = imgData.src;
        thumbImg.alt = imgData.alt;
        thumbImg.loading = 'lazy';
        item.appendChild(thumbImg);
        thumbsGrid.appendChild(item);
      });

      gallery.appendChild(thumbsGrid);
    }

    container.insertBefore(gallery, container.firstChild);
  }

  // ── 3. Advanced Lightbox ──────────────────────────────────────────────────
  function initLightbox() {
    var lightbox   = document.getElementById('cpl-lightbox');
    var lbImg      = document.getElementById('cpl-lightbox-img');
    var closeBtn   = document.getElementById('cpl-lightbox-close');
    var prevBtn    = document.getElementById('cpl-lightbox-prev');
    var nextBtn    = document.getElementById('cpl-lightbox-next');
    var counter    = document.getElementById('cpl-lightbox-counter');

    if (!lightbox || !lbImg) return;

    function updateLightbox() {
      var data = galleryImages[lightboxIndex];
      if (!data) return;
      lbImg.src = data.src;
      lbImg.alt = data.alt;
      if (counter) counter.textContent = (lightboxIndex + 1) + ' / ' + galleryImages.length;
    }

    function openAt(index) {
      if (galleryImages.length === 0) return;
      lightboxIndex = index;
      updateLightbox();
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.classList.remove('is-open');
      lbImg.src = '';
      document.body.style.overflow = '';
    }

    function prev() {
      lightboxIndex = (lightboxIndex - 1 + galleryImages.length) % galleryImages.length;
      updateLightbox();
    }

    function next() {
      lightboxIndex = (lightboxIndex + 1) % galleryImages.length;
      updateLightbox();
    }

    // Gallery trigger (delegated)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cpl-index]');
      if (trigger) { e.preventDefault(); openAt(parseInt(trigger.dataset.cplIndex, 10)); return; }
      if (e.target === lightbox) close();
    });

    // Keyboard on gallery items
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var trigger = e.target.closest('[data-cpl-index]');
        if (trigger) { e.preventDefault(); openAt(parseInt(trigger.dataset.cplIndex, 10)); }
      }
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape')      close();
      if (e.key === 'ArrowLeft')   prev();
      if (e.key === 'ArrowRight')  next();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn)  prevBtn.addEventListener('click', prev);
    if (nextBtn)  nextBtn.addEventListener('click', next);
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    buildPills();
    buildGallery();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
